<template>
   <template v-if="variants.v1 === variant">
   <section data-anim-wrap class="pageHeader -type-1">
    <div data-anim-child="fade delay-1" class="pageHeader__image">
  <img
    :src="isMobileDevice
      ? (vars.mobileBackgroundImage || vars.backgroundImage)
      : vars.backgroundImage"
    alt="image"
  />
</div>

  <div class="container">
    <h1 data-anim-child="slide-up delay-1" class="pageHeader__title tw-text-white">{{ vars.mainTitleText }}</h1>

    <div data-anim-child="slide-up delay-2" class="pageHeader-nav">
      <!-- … -->
    </div>
  </div>
</section>
</template>
<template v-else-if="variants.v4 === version">
  <section data-anim-wrap class="pageHeader -type-1">
      <div data-anim-child="fade delay-1" class="pageHeader__image">
        <img
          :src="isMobileDevice
            ? (variables.mobileBackgroundImage || variables.backgroundImage)
            : variables.backgroundImage"
          alt="image"
        />
      </div>

      <div class="container">
        <h1 data-anim-child="slide-up delay-1" class="pageHeader__title">{{variables.mainTitleText}}</h1>

        <div data-anim-child="slide-up delay-2" class="pageHeader-nav tw-absolute tw-bottom-12 tw-z-10 tw-gap-4 lg:tw-gap-10">
          <nuxt-link
              v-for="(tab, index) in tabs"
              :key="`knowledge-hub-tab-${index}`"
              :class="activeTab === tab.name ? 'n-primary-link-btn' : 'n-primary-link-btn-disabled'"
              :to="`/knowledge-hub/${tab.name}`"
              :external="true"
              style="text-transform: uppercase; text-align: center; font-weight: bold"
              class="tw-col-span-6 tw-px-4 tw-py-6 lg:tw-col-span-2 n-link"
            >
              {{ tab.title }}
          </nuxt-link>
        </div>
      </div>
    </section>

  </template>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';

export default defineNuxtComponent({
  name: 'IntroSection',

  mixins: [ComponentMixin],

  data() {
    return {
      variants: {
        v1: 'v1',
        v4: 'v4',
      },
    };
  },

  props: {
    version: {
      type: String,
      required: false,
    },
    variables: {
      type: Object,
      required: false,
    },
    tabs: {
      type: Array,
      required: false,
    },
    activeTab: {
      type: String,
      required: false,
    },
  }
});
</script>
